import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '年齡超過70歲或低於14歲的人',
  '正在服用利尿劑、鎮靜劑和抗癲癇藥物的人',
  '有步態障礙、昏迷或頭暈症狀的人',
  '身體虛弱、視力和聽力障礙、排尿和排泄障礙、骨質疏鬆的人',
  '其他有跌倒風險的人',
];

const CautionList = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="特別注意，如果您屬於以下類別，請注意防止跌倒" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{ fontWeight: '400', fontSize: '14px', lineHeight: '40px' }}
          >
            {i + 1}) {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default CautionList;
